import { createFileRoute, Outlet } from '@tanstack/react-router'
export const Route=createFileRoute('/system/access/roles')({component:Outlet})
